import { useI18n } from "../../i18n/localization";

// Outgoing call — shown to the field officer while the chosen officer is rung
// (docs/design/05-uiux-spec.md §3.3).
export function Calling({ remoteName, onCancel }: { remoteName: string | null; onCancel: () => void }) {
  const { t, dir } = useI18n();
  return (
    <main style={center} dir={dir}>
      <div style={{ textAlign: "center" }}>
        <div style={{ fontSize: 17, color: "#14305f", marginBottom: 6 }}>{t.call.callingTitle}</div>
        {remoteName && <div style={{ fontSize: 15, color: "#1e2a3a", marginBottom: 24 }}>{remoteName}</div>}
        <div style={pulse} />
        <button onClick={onCancel} style={dangerBtn}>{t.call.cancel}</button>
      </div>
    </main>
  );
}

const center: React.CSSProperties = {
  height: "100vh", display: "flex", alignItems: "center", justifyContent: "center",
  fontFamily: "Segoe UI, Arial, sans-serif", background: "#eef2f7"
};
const pulse: React.CSSProperties = {
  width: 64, height: 64, borderRadius: "50%", background: "#1d4ed8", margin: "0 auto 24px", opacity: 0.85
};
const dangerBtn: React.CSSProperties = {
  background: "#dc2626", color: "#fff", border: "none", borderRadius: 6, padding: "8px 22px", fontSize: 14, cursor: "pointer"
};
